import { Box, Image, Spinner } from "@chakra-ui/react";
import { useState, useRef, useEffect } from "react";

const MediaWithLoader = ({ media, type = "image", aspectRatio = "1 / 1" }) => {
  const [loading, setLoading] = useState(true);
  const mediaRef = useRef(null);

  const handleLoad = () => {
    setLoading(false);
  };

  // Show spinner for at least 1 second (testing purpose)
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  if (!media) return null;

  return (
    <Box
      position="relative"
      w="full"
      aspectRatio={aspectRatio}
      minH="300px" // 👈 fallback height if aspectRatio fails
      bg="gray.100"
      borderRadius="md"
      overflow="hidden"
    >
      {/* Spinner on top */}
      {loading && (
        <Spinner
          thickness="4px"
          speed="0.65s"
          emptyColor="gray.200"
          color="blue.500"
          size="xl"
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          zIndex={10}
        />
      )}

      {/* Media (video/image) */}
      {type === "video" ? (
        <video
          ref={mediaRef}
          autoPlay
          loop
          muted
          playsInline
          onLoadedData={handleLoad}
          onCanPlay={handleLoad}
          onError={handleLoad}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: loading ? 0 : 1,
            transition: "opacity 0.3s ease",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 1,
          }}
        >
          <source src={media} type="video/mp4" />
        </video>
      ) : (
        <Image
          ref={mediaRef}
          src={media}
          alt="Media"
          onLoad={handleLoad}
          onError={handleLoad}
          position="absolute"
          top={0}
          left={0}
          width="100%"
          height="100%"
          objectFit="cover"
          opacity={loading ? 0 : 1}
          transition="opacity 0.3s ease"
          zIndex={1}
        />
      )}
    </Box>
  );
};

export default MediaWithLoader;
